import { render } from "./DocumentTable.vue?vue&type=template&id=33a4c9b3&scoped=true&ts=true"
import script from "./DocumentTable.ts?vue&type=script&lang=ts"
export * from "./DocumentTable.ts?vue&type=script&lang=ts"

import "./DocumentTable.scss?vue&type=style&index=0&id=33a4c9b3&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33a4c9b3"]])

export default __exports__